import React, { Component } from 'react';
import PropTypes from 'prop-types';

//Components
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { Button } from 'devextreme-react';

// css
import { withStyles } from '@material-ui/core';
const styles = theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    alignCenter: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    textField: {
        minWidth: '100%',
    },
});


const DialogTitle = withStyles(styles)(props => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});


const DialogContent = withStyles(theme => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
}))(MuiDialogActions);


class ConfirmationDialog extends Component {
    constructor(props) {
        super(props);

        this.triggerAction = this.triggerAction.bind(this); 
        this.triggerLeftAction = this.triggerLeftAction.bind(this);
    }

    triggerAction() {
        this.props.showDialog();
        this.props.action();
    }

    triggerLeftAction() {
        this.props.showDialog();
        this.props.leftAction();
    }

    render() {
        const { classes, title, message, isOpen, showDialog, buttonLeftText, buttonRightText  } = this.props;

        return (
            <Dialog
                open={isOpen}
                onClose={showDialog}
                aria-labelledby="draggable-dialog-title"
                maxWidth='xs'
            >
                <DialogTitle id="customized-dialog-title" onClose={showDialog}>
                    {title}
                </DialogTitle>
                <DialogContent dividers>
                    <Typography gutterBottom >
                        {message}
                    </Typography>
                </DialogContent>
                <DialogActions className={classes.alignCenter}>
                    
                    <Button
                        width='auto'
                        text={buttonLeftText !== undefined ? buttonLeftText : "Annulla"}
                        type="normal"
                        stylingMode="outlined"
                        onClick={this.props.leftAction === undefined ? showDialog : this.triggerLeftAction}
                    />

                    <Button
                        width='auto'
                        text={buttonRightText !== undefined ? buttonRightText : "Conferma"}
                        type="default"
                        stylingMode="contained"
                        onClick={this.triggerAction}
                    />
                </DialogActions>
            </Dialog>
        );
    }
}

ConfirmationDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    showDialog: PropTypes.func.isRequired,  // handler apertura e chiusura Dialog

    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    buttonRightText: PropTypes.string,  // testo bottone dx
    buttonLeftText: PropTypes.string,   // testo bottone sx

    action: PropTypes.func.isRequired,  // funzione lanciata cliccando bottone a dx
    leftAction: PropTypes.func,         // se definita, funzione lanciata cliccando bottone a sx
};

export default withStyles(styles)(ConfirmationDialog);

/*
 




            <Dialog
                open={isOpen}
                onClose={showDialog}
                PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title"
                maxWidth='xs'
            >
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                    {title}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {message}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className={classes.dialogActions}>

                    <Button
                        onClick={this.props.leftAction === undefined ? showDialog : this.triggerLeftAction}
                        color="primary"
                    >
                        {buttonLeftText !== undefined ? buttonLeftText : "Annulla"}
                    </Button>

                    <Button
                        autoFocus
                        onClick={this.triggerAction}
                        color="primary"
                    >
                        {buttonRightText !== undefined ? buttonRightText : "Conferma"}
                    </Button>
                </DialogActions>
            </Dialog>
 
 
 
 */